// extracted by mini-css-extract-plugin
export default {"form":"ProductEditor_form__6eZ0E","select":"ProductEditor_select__NWlGP","input":"ProductEditor_input__1kZde","div":"ProductEditor_div__gVOki"};